export default {
  common: {
    nav: {
      home: "Home",
      find_offer_help: "Trova / Offri aiuto",
      celebrate: "Celebra una vita",
      family_tree: "Albero genealogico",
      events: "Eventi",
      civic_reports: "Rapporti civici",
      neighborhood_pulse: "Pulso di quartiere",
      weather: "Meteo",
      nature: "Natura",
      marketplace: "Mercato",
      news: "Notizie",
      causes: "Cause",
      more: "Altro",
    },
    header: { sign_in: "Accedi", join: "Unisciti a Social Pulse", language: "Lingua", search: "Cerca" },
    tagline: "Connettere le comunità · Dare potere alle vite · Costruire capitale sociale",
    locality: { viewing_from: "Stai visualizzando da", change: "Cambia", set_your_location: "Imposta la tua posizione" },
    news: { title: "Il tuo briefing quotidiano.", play_briefing: "Riproduci briefing quotidiano", listen: "Ascolta", translate: "Traduci" },
  },
};
